import template from './sw-cms-preview-text.html.twig';
import './sw-cms-preview-text.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
